module.exports = __webpack_public_path__ + "img/fyt_p7.c72677b5.png";